export default __webpack_public_path__ + "static/quergedacht_light-b6bda74ee832ced6f1c6a86d145c2ab5.svg";